<template>
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>
<script lang="ts" setup>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100%;
  font-size: @font-size-base;
  color: @text-color;
}

#nprogress .spinner {
  display: none !important;
}
</style>
